import { Component } from "preact";
import { isNullOrUndefined } from "util";
import DatePicker from "../../async/date-picker";
import _constant from "../../../../utils/constants";
import { logEvent } from "../../../../utils/logger";
import { toDate } from "../../../../utils/utility";

export default class DateInput extends Component {
  constructor(props) {
    super(props);
    this.state = { isError: false, errorName: "Value is required", inputValue: "" };
    this.updateValue = this.updateValue.bind(this);
    this.clearErrors = this.clearErrors.bind(this);
    this.dateFormat = `DD${_constant.DATE_ORDINAL}MM${_constant.DATE_ORDINAL}YYYY`;
  }

  getdisplayDates = maxDate => {
    if (maxDate) {
      const date = new Date(toDate(maxDate));
      if (date < new Date()) {
        return { month: date.getMonth(), year: date.getFullYear() };
      }
    }
    return { month: "", year: "" };
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  updateValue = value => {
    this.clearErrors();
    if (value) {
      this.setState({ inputValue: value.trim() });
      this.props.updateFormValue(this.props.index, this.state.inputValue);
    }
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "date form field", fieldName: this.props.name });
  };

  shouldComponentUpdate(nextProps, nextSate) {
    if (nextSate.isError !== this.state.isError) {
      return true;
    }
    if (
      nextProps.inputValue == this.props.inputValue &&
      nextProps.isError == this.props.isError &&
      nextProps.errorName == this.props.errorName
    ) {
      return false;
    }
  }

  render({ name, constraints, placeholder, subText }) {
    const datePickerOptions = {
      selectedDate: "",
      minDate: constraints.minValue ? constraints.minValue : "",
      maxDate: constraints.maxValue ? constraints.maxValue : "",
      displayDate: this.getdisplayDates(constraints.maxValue)
    };
    return (
      <div className="pos-r">
        <DatePicker
          minDate={datePickerOptions.minDate}
          maxDate={datePickerOptions.maxDate}
          selectedDate={datePickerOptions.selectedDate}
          datePickerOpened={false}
          dateInputFormat={this.dateFormat}
          showCalendarIcon
          placeholder={placeholder}
          name={name}
          onDateChange={this.updateValue}
          onDateInputClick={this.clearErrors}
          displayedMonth={datePickerOptions.displayDate.month}
          displayedYear={datePickerOptions.displayDate.year}
        />
        {subText && <p className="input-info">{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/date/index.js